import { RIGHTS_IS_CREATE, RIGHTS_PAYMENT_ACCOUNTS } from '@app/constants';
import { useAccessRights } from '@app/hooks';

export const usePaymentAccountsPageHeader = () => {
  const { hasUserRight: hasUserRightToCreatePaymentsAccount } = useAccessRights(
    RIGHTS_PAYMENT_ACCOUNTS,
    RIGHTS_IS_CREATE
  );

  return {
    hasUserRightToCreatePaymentsAccount,
  };
};
